<div id="currentTrainers-details-container" class="currentTrainer container" *ngIf="currentTrainer">
    <form (submit)="validate($event)">
        <div class="row">
            <div class="col-md-7">
                <div class="row">
                    <div class="col-md-2">
                        <label for="firstName" class="required">{{ 'trainer-detail.firstName' | translate}}:</label>
                    </div>
                    <div class="col-md-2">
                        <select class="form-control" id="title"
                                required
                                [(ngModel)]="currentTrainer.title" name="title"
                                #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                            <option value="MRS">M</option>
                            <option value="MS">Mme</option>
                        </select>
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.title}}</label>
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" id="firstName"
                               required
                               [(ngModel)]="currentTrainer.firstName" name="firstName"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.firstName}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="lastName" class="required">{{ 'trainer-detail.lastName' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control" id="lastName"
                               required
                               [(ngModel)]="currentTrainer.lastName" name="lastName"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.lastName}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="lastName" class="required">{{ 'trainer-detail.email' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control" id="email"
                               [(ngModel)]="currentTrainer.email" name="email"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.email}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="phone">{{ 'trainer-detail.phone' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control" id="phone"
                               [(ngModel)]="currentTrainer.phone" name="phone"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.phone}}</label>
                    </div>
                </div>
                <div class="separator">
                    &nbsp;
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="address1">{{ 'trainer-detail.address1' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control" id="address1"
                               [(ngModel)]="currentTrainer.address1" name="address1"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.address1}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="address2"></label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control" id="address2"
                               [(ngModel)]="currentTrainer.address2" name="address2"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.address2}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="zipCode">{{ 'trainer-detail.zipCode' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input type="number" class="form-control" id="zipCode"
                               [(ngModel)]="currentTrainer.zipCode" name="zipCode"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.zipCode}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="city">{{ 'trainer-detail.city' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control" id="city"
                               [(ngModel)]="currentTrainer.city" name="city"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.city}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="countryCode">{{ 'trainer-detail.countryCode' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control" id="countryCode"
                               [(ngModel)]="currentTrainer.countryCode" name="countryCode"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.countryCode}}</label>
                    </div>
                </div>
                <div class="separator">
                    &nbsp;
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="company" class="required">{{ 'trainer-detail.company' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input auto-complete [(ngModel)]="currentTrainer.company.name"
                               [source]="searchCompanies.bind(this)"
                               value-property-name="id" [list-formatter]="myListFormatter" [accept-user-input]="false"
                               [min-chars]="1" [max-num-list]="14" display-property-name="name" id="company"
                               class="form-control" (valueChanged)="changeCompany($event)" name="company"
                               (focus)="focusOnCompanyAutocomplete()" *jhiHasAnyAuthority="'ROLE_ADMIN'"
                               autocomplete="off">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.company.name}}</label>
                    </div>
                    <div class="col-md-1">
                            <span class="check" *ngIf="companySelected()"><i class="fa fa-check"
                                                                           aria-hidden="true"></i></span>
                        <span class="times" *ngIf="!companySelected()"><i class="fa fa-times"
                                                                        aria-hidden="true"></i></span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="job">{{ 'trainer-detail.job' | translate}}:</label>
                    </div>
                    <div class="col-md-5">
                        <input type="text" class="form-control" id="job"
                               [(ngModel)]="currentTrainer.job" name="job"
                               #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.job}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label for="bio">{{ 'trainer-detail.bio' | translate}}:</label>
                    </div>
                    <div class="col-md-10">
                    <textarea class="form-control" id="bio"
                              [(ngModel)]="currentTrainer.bio" name="bio"
                              #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                    </textarea>
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{currentTrainer.bio}}</label>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div>
                    <input type="checkbox" id="internal"
                           [(ngModel)]="currentTrainer.interne" name="internal"
                           #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                    <label for="internal">{{ 'trainer-detail.internal' | translate}}</label>
                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{getBoolTranslateKey(currentTrainer.interne) |
                        translate}}</label>
                </div>
                <div>
                    <input type="checkbox" id="active"
                           [(ngModel)]="currentTrainer.active" name="active"
                           #name="ngModel" *jhiHasAnyAuthority="'ROLE_ADMIN'">
                    <label for="active">{{ 'trainer-detail.active' | translate}}</label>
                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{getBoolTranslateKey(currentTrainer.active) |
                        translate}}</label>
                </div>
                <div *ngFor="let language of availableLanguages">
                    <input
                            type="checkbox"
                            [(ngModel)]="currentTrainerLanguages[language.code]"
                            [name]="language.code"
                            *jhiHasAnyAuthority="'ROLE_ADMIN'"
                    />
                    <label>{{ 'trainer-detail.languages' | translate}} {{ 'global.language.' + language.code | translate }}</label>
                    <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{getBoolTranslateKey(currentTrainerLanguages[language.code]) |
                        translate}}</label>
                </div>
            </div>
        </div>
        <br>
        <div style="margin:0 30px 30px;" *jhiHasAnyAuthority="'ROLE_ADMIN'">
            <button class="btn btn-default" type="submit" name="submit">{{ 'trainer-detail.save' | translate}}</button>
        </div>
    </form>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/detail/description/description.component.html